import { useForm, FieldValues, FormProvider as RhFormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { FieldRevertProvider } from '@cbridge-tools/field';
import { UnsavedMessage } from '../UnsavedMessage/UnsavedMessage';
import { IFormProviderProps } from './FormProvider.interface';

export const FormProvider = <TFieldValues extends FieldValues = FieldValues,>(props: IFormProviderProps<TFieldValues>) => {
  'use no memo'; //Used because otherwise, the validation of fields in the child component does not update

  const {
    schema, values, defaultValues, disabled, enableFieldRevert = true, mode = 'onSubmit', children,
  } = props;

  const form = useForm({
    mode,
    values,
    defaultValues,
    disabled,
    resolver: yupResolver(schema),
  });

  // Elements with attribute 'data-form-edit-mode' styled in theme.ts
  return (
    <RhFormProvider {...form}>
      <UnsavedMessage />
      <Box data-form-edit-mode={disabled ? undefined : ''} sx={{
        display: 'contents',
      }}>
        <FieldRevertProvider enabled={enableFieldRevert && !disabled}>
          {children}
        </FieldRevertProvider>
      </Box>
    </RhFormProvider>
  );
};
